module.exports = __webpack_public_path__ + "img/jobUnselhover.326a6a07.svg";